// ─────────────────────────────────────────────────────────────────────────────
// platformPresets.js
//
// Mirror of backend-/config/platformPresets.js — change both together.
//
// Why these four are not built like YouTube and Facebook: those two publish a
// single fixed ingest host, so the app stores a stream key and builds the URL
// itself. LinkedIn and X mint an ingest URL per broadcast, and Kick's is an
// Amazon IVS endpoint that varies by account, so there is nothing stable to
// hardcode. They take a URL and a key, and go out through the same copy
// pipeline as every other destination.
//
// `defaultUrl` is filled in only where the host is genuinely stable. A wrong
// default is worse than none: it fails at stream time rather than at save time.
// ─────────────────────────────────────────────────────────────────────────────

export const PLATFORM_PRESETS = [
  {
    id: "linkedin",
    label: "LinkedIn",
    kind: "linkedin",
    defaultUrl: null,
    where: "LinkedIn Live creates a server URL and stream key for each broadcast — copy both from the LinkedIn post composer when you schedule it."
  },
  {
    id: "x",
    label: "X",
    kind: "x",
    defaultUrl: null,
    where: "In X, open Media Studio → Producer → create a source. It shows an RTMP URL and a stream key."
  },
  {
    id: "instagram",
    label: "Instagram",
    kind: "instagram",
    defaultUrl: "rtmps://live-upload.instagram.com:443/rtmp/",
    verifyUrl: true,
    where: "Instagram Live Producer shows a stream URL and key. RTMP is not enabled on every account — check the URL matches what Instagram shows you."
  },
  {
    id: "kick",
    label: "Kick",
    kind: "kick",
    defaultUrl: null,
    where: "Kick → Settings → Stream Key shows a stream URL and a stream key. Copy the URL exactly as shown."
  }
];

export const presetFor = (id) =>
  PLATFORM_PRESETS.find((p) => p.id === (id || "").toLowerCase()) || null;

/**
 * The label a destination row should show before the user names it. Mirrors
 * buildManualDestinations on the server, which counts ids per platform rather
 * than by array position.
 */
export const presetLabel = (preset, ordinal) =>
  preset ? `${preset.label} ${ordinal}` : `RTMP ${ordinal}`;
